// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.terms {
  max-width: 800px;
  margin: 60px auto 100px;
  padding: 40px 20px;
  background-color: #0d0d0d;
  color: #f2f2f2;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  line-height: 1.7;
  font-size: 1rem;
  box-shadow: 0 4px 15px rgba(247, 147, 26, 0.8);
  border-radius: 8px;
}

.terms h2 {
  font-size: 2rem;
  margin-bottom: 25px;
  color: #f7931a;
  text-align: center;
  font-weight: 600;
  border-bottom: 2px solid #f7931a;
  padding-bottom: 10px;
}

.terms h3 {
  margin-top: 25px;
  margin-bottom: 10px;
  color: #ffa733;
  font-weight: 600;
}

.terms p {
  margin-bottom: 20px;
  text-align: justify;
}

/* Responsive */
@media (max-width: 768px) {
  .terms {
    padding: 30px 15px;
    font-size: 0.95rem;
  }

  .terms h2 {
    font-size: 1.6rem;
  }
}

@media (max-width: 480px) {
  .terms {
    padding: 20px 10px;
    font-size: 0.9rem;
  }

  .terms h2 {
    font-size: 1.4rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/css/Terms.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,4DAA4D;EAC5D,gBAAgB;EAChB,eAAe;EACf,8CAA8C;EAC9C,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".terms {\n  max-width: 800px;\n  margin: 60px auto 100px;\n  padding: 40px 20px;\n  background-color: #0d0d0d;\n  color: #f2f2f2;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n  line-height: 1.7;\n  font-size: 1rem;\n  box-shadow: 0 4px 15px rgba(247, 147, 26, 0.8);\n  border-radius: 8px;\n}\n\n.terms h2 {\n  font-size: 2rem;\n  margin-bottom: 25px;\n  color: #f7931a;\n  text-align: center;\n  font-weight: 600;\n  border-bottom: 2px solid #f7931a;\n  padding-bottom: 10px;\n}\n\n.terms h3 {\n  margin-top: 25px;\n  margin-bottom: 10px;\n  color: #ffa733;\n  font-weight: 600;\n}\n\n.terms p {\n  margin-bottom: 20px;\n  text-align: justify;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .terms {\n    padding: 30px 15px;\n    font-size: 0.95rem;\n  }\n\n  .terms h2 {\n    font-size: 1.6rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .terms {\n    padding: 20px 10px;\n    font-size: 0.9rem;\n  }\n\n  .terms h2 {\n    font-size: 1.4rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
